// extracted by mini-css-extract-plugin
export default {"root":"Gate_root__YteZc","fill":"Gate_fill__o7WCJ","processing":"Gate_processing__tQo4v","invisible":"Gate_invisible__rkagX"};